import { IAttrValue } from "@multiweb/types/contracts";
import { EMPTY_ITEM_RIGHTS_COLLECTION } from "Global/Base/Rights/RightTypes";
import { ElementUtils } from "UI/UI.ElementarControls/Helpers/ElementUtils";
import { FlagEdit } from "UI/UI/UI/Controls/FlagEdit";
import { IValidatable } from "../../../../UI.BaseControls/ControlInterfaces";
import { ValidatableControl } from "../../../../UI.BaseControls/ValidatableControl";
import { Column } from "../../Columns/Column";
import { EditItemTemplate } from "../EditItemTemplate";

export class FlagEditTemplate extends EditItemTemplate {
    protected override _createEditElement(column: Column, dataSet: IAttrValue[], parentItem: HTMLElement): { element: HTMLElement; validatableControl: IValidatable } {
        const feElement = document.createElement("div");
        const fe = new FlagEdit({
            element: feElement,
            originalRightsDefinition: EMPTY_ITEM_RIGHTS_COLLECTION,
            attrName: column.attrName,
        });
        fe.enabledVisual = false; //předejde se tak možnosti editovat hodnotu dříve než to povolí práva
        const data = this._getDataFromSet(dataSet);
        fe.parse(data ? data.toString() : "");
        fe.valueChanged.add((sender) => {
            ElementUtils.callEvent(parentItem, "valuechanged", { value: sender.controlValue, column: this.parentColumn });
        });
        return { element: feElement as HTMLElement, validatableControl: new ValidatableControl(feElement as HTMLElement) };
    }

    public override async updateData(dataSet: IAttrValue[], item: HTMLElement): Promise<void> {
        ((item as any).tscControl as FlagEdit).parse(await this.parentColumn.formatValue(this._getDataFromSet(dataSet)));
    }
}
